module.exports = "/_next/static/images/img__3-2be47b46d0a58a03d3b8ed3ffdf4ed95.png";